import React, { useEffect, useState } from "react";
import { useParams, NavLink } from "react-router-dom";
import ContactFormPages from "../components/ContactFormPages";
import { Images } from "../assets";
import { useTranslation } from "react-i18next";

const NewsDetails = () => {
  const { id } = useParams();
  const [actualite, setActualite] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch(`/api/news/${id}`);
        const data = await response.json();
        setActualite(data);
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };

    fetchNews();
  }, [id]);

  if (!actualite) {
    return <div>{t("loading")}</div>;
  }

  return (
    <div className="flex flex-col mx-5 md:mx-10 my-10 gap-5">
      {/* Header */}
      <section className="flex flex-col md:flex-row items-start md:items-center justify-between gap-5 w-full h-full mb-0 md:mb-16">
        {/* Back Button */}
        <NavLink to={"/"} className={"w-fit h-fit"}>
          <div className="w-16 h-16 bg-orange rounded-full flex items-center justify-center mb-5 md:mb-0 md:mr-10 hover:brightness-75 transition">
            <img src={Images.ARROW_BACK} alt={t("back")} className="w-8 h-8" />
          </div>
        </NavLink>

        {/* Title */}
        <h1 className="font-title text-4xl md:text-5xl text-white flex-grow text-start">
          {t("news.tran")}:{" "}
          <span className="text-orange">{actualite.title}</span>
        </h1>

        {/* Spacer */}
        <div className="w-16 h-16 invisible"></div>
      </section>

      {/* Main Content Row */}
      <section className="flex flex-col md:flex-row items-start gap-5 w-full overflow-hidden">
        {actualite.content.length > 0 && (
          <div className="flex flex-col text-start w-full md:w-2/5">
            <h2 className="font-title text-xl mb-2">
              {actualite.content[0].title}
            </h2>
            <p className="text-justify">{actualite.content[0].content}</p>
          </div>
        )}
        {(actualite.image_type ?? "").startsWith("video/") ? (
        <video
          className="rounded-lg w-full md:w-3/5 h-48 md:h-52 object-cover"
          src={actualite.image}
          controls
        />
      ) : (
        <img
          src={actualite.image}
          alt={actualite.title}
          className="rounded-lg w-full md:w-3/5 h-48 md:h-52 object-cover"
        />
      )}
      </section>

      {/* Second Text Block */}
      {actualite.content.slice(1).map((item, index) => (
        <div key={index} className="flex flex-col text-start">
          <h2 className="font-title text-xl mb-2">{item.title}</h2>
          <p className="text-justify">{item.content}</p>
        </div>
      ))}

      <ContactFormPages />
    </div>
  );
};

export default NewsDetails;
